/* WaxCycle 5.1.1 - gedrag n.a.v. de reviews (19 sep en 3 okt 2026). */
/* Geladen onderaan de body vanuit layout/theme.liquid. */
(function () {
  var mqMobile = window.matchMedia('(max-width: 768px)');
  var KEY = 'wc_filter_open';

  /* Filtergroepen zijn accordeons op mobiel, altijd open op desktop.            */
  /* Okt 2026: na een keuze herlaadt de pagina; groepen die open stonden of een   */
  /* actieve keuze hebben, blijven nu open (eerder klapte alles dicht).           */
  function groupKey(g) { var s = g.querySelector('summary'); return s ? s.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function stored() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function remember() {
    var open = [];
    document.querySelectorAll('.collection-filter__scrollable > .collection-filter__group').forEach(function (g) { if (g.open) open.push(groupKey(g)); });
    try { sessionStorage.setItem(KEY, JSON.stringify(open)); } catch (e) {}
  }
  function applyFilterAccordions() {
    var groups = document.querySelectorAll('.collection-filter__scrollable > .collection-filter__group');
    var s = stored();
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (!mqMobile.matches) { g.open = true; continue; }
      if (g.dataset.wcTouched) continue;
      var want = !!g.querySelector('.tag--active') || (s ? s.indexOf(groupKey(g)) > -1 : i === 0);
      g.open = want;
    }
  }
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('collection-filter__group') && mqMobile.matches) {
      e.target.dataset.wcTouched = '1'; remember();
    }
  }, true);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.collection-filter__group .tag a');
    if (a && mqMobile.matches) remember();
  }, true);

  /* Winkelwagen bijwerken zonder de pagina te verversen (Cleaning Kit-tegels). */
  window.wcCartAdded = function () {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-link__count, .cart-link__bubble-num, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('.cart-link__bubble').forEach(function (el) { el.classList.add('cart-link__bubble--visible'); });
    }).catch(function () {});
    var opener = Array.prototype.find.call(document.querySelectorAll('.js-drawer-open-cart'), function (el) { return el.offsetParent !== null; });
    if (opener) { setTimeout(function () { opener.click(); }, 150); }
  };
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-wc-ajax-add]')) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { if (window.jQuery) window.jQuery('body').trigger('added.ajaxProduct'); window.wcCartAdded(); })
      .catch(function () { f.removeAttribute('data-wc-ajax-add'); f.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* Collectiekop op mobiel: lange SEO-intro ingeklapt tot 3 regels, met "Lees meer". */
  function clampIntro() {
    var lead = document.querySelector('.wc-pagehead__lead--seo');
    if (!lead || lead.dataset.wcClamp) return;
    lead.dataset.wcClamp = '1';
    if (!mqMobile.matches) return;
    lead.classList.add('is-clamped');
    if (lead.scrollHeight <= lead.clientHeight + 4) { lead.classList.remove('is-clamped'); return; }
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'wc-more';
    b.textContent = lead.getAttribute('data-more') || 'Lees meer';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var open = lead.classList.toggle('is-clamped') === false;
      b.textContent = open ? (lead.getAttribute('data-less') || 'Minder') : (lead.getAttribute('data-more') || 'Lees meer');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    lead.insertAdjacentElement('afterend', b);
  }


  /* Okt 2026: interne links in teksten (artikelen, pagina's, beschrijvingen) staan als /pages/... */
  /* zonder taalvoorvoegsel. In een andere taal/markt (bv. /de-de) zetten we het voorvoegsel ervoor, */
  /* zodat bezoekers in hun eigen taal blijven. */
  function localizeLinks() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (root === '/' ) return;
    var pre = root.replace(/\/$/, '');
    document.querySelectorAll('a[href^="/"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (h.indexOf('//') === 0 || h.indexOf(pre + '/') === 0 || h === pre) return;
      if (/^\/(cdn|s\/files|checkouts?|account\/logout|apps|tools)\b/.test(h)) return;
      a.setAttribute('href', pre + h);
    });
  }

  /* 4 okt 2026 (5.2.3): Re-Wax-strippenkaarten (SKU WC-REWAX-3X/5X/10X) buiten NL: kleine grijze regel */
  /* onder de bundel in de winkelwagen met de retourzending die bij het afrekenen wordt berekend.     */
  /* Tarieven = verzendprofielen "Re-Wax 3x/5x/10x bundel" (N x landtarief). In NL inbegrepen: geen regel. */
  var WC_ZONES = { DE: 790 };
  'AT,BE,EE,FR,IS,IE,IT,LV,LU,PT,ES,SE,GB'.split(',').forEach(function (c) { WC_ZONES[c] = 990; });
  'BG,HR,CY,CZ,DK,FI,GR,HU,LT,MT,NO,PL,CH'.split(',').forEach(function (c) { WC_ZONES[c] = 1390; });
  'RO,SK,SI,US'.split(',').forEach(function (c) { WC_ZONES[c] = 1790; });
  'LI,NZ,ZA'.split(',').forEach(function (c) { WC_ZONES[c] = 2490; });
  var WC_WORD = { nl: 'retourzending bij afrekenen', de: 'Rückversand an der Kasse', en: 'return shipping at checkout', fr: 'retour à la commande', es: 'envío de vuelta al pagar', it: 'spedizione di ritorno al checkout', pl: 'wysyłka zwrotna przy kasie', cs: 'zpáteční doprava v pokladně', sk: 'spätná doprava v pokladni', sv: 'returfrakt i kassan', pt: 'envio de regresso no checkout' };
  function bundleNotes(cart) {
    var cc = (window.Shopify && Shopify.country) || 'NL';
    var rate = WC_ZONES[cc];
    document.querySelectorAll('.wc-bship').forEach(function (el) { el.remove(); });
    if (!rate || !cart || !cart.items) return;
    var lang = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
    var word = WC_WORD[lang] || WC_WORD.en;
    cart.items.forEach(function (it) {
      var m = /WC-REWAX-(\d+)X/i.exec(it.sku || '');
      var n = m ? parseInt(m[1], 10) : 1;
      if (n < 2) return;
      var amount = '€' + (rate / 100).toFixed(2).replace('.', ',');
      document.querySelectorAll('[data-cart-item-id="' + it.key + '"]').forEach(function (row) {
        var anchor = row.querySelector('[data-cart-item-variant-title]') || row.querySelector('[data-cart-item-title]');
        if (!anchor) return;
        var d = document.createElement('div');
        d.className = 'wc-bship';
        d.style.cssText = 'font-size:12px;opacity:.7;margin-top:2px;';
        d.textContent = '+ ' + n + ' × ' + amount + ' ' + word;
        anchor.insertAdjacentElement('afterend', d);
      });
    });
  }
  function refreshBundleNotes() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(bundleNotes).catch(function () {});
  }
  document.addEventListener('cart:updated', function (e) { if (e.detail && e.detail.cart) { bundleNotes(e.detail.cart); } else { refreshBundleNotes(); } });

  function runAll() { applyFilterAccordions(); clampIntro(); localizeLinks(); refreshBundleNotes(); }

  if (mqMobile.addEventListener) { mqMobile.addEventListener('change', applyFilterAccordions); }
  else if (mqMobile.addListener) { mqMobile.addListener(applyFilterAccordions); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
  window.addEventListener('load', applyFilterAccordions);
  window.setTimeout(applyFilterAccordions, 400);
})();
